import { Fragment } from 'react';
import { DebugPanel } from '@components';
import { Button, Container, Drawer, Grid, IconButton, MobileStepper } from '@mui/material';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { AccountabilityPartnerResponse } from './AccountabilityPartnerResponse';
import { FreeTextResponse } from '@components/SurveyDrawer/FreeTextResponse';
import { MultiSelectResponse } from '@components/SurveyDrawer/MultiSelectResponse';
import { MutuallyExclusiveResponse } from '@components/SurveyDrawer/MutuallyExclusiveResponse';
import { Question } from '@components/SurveyDrawer/Question';
import { SurveyTitle } from '@components/SurveyDrawer/SurveyTitle';
import { useSurveyDrawerControllerContext } from '@components/SurveyDrawer/SurveyDrawerControllerProvider';
import { useNavigationEligibility } from '@components/SurveyDrawer/NavigationEligibilityContextProvider';
import { DropdownResponse } from './DropdownResponse';

export const SurveyDrawer2 = () => {
  const { nextEnabled, prevEnabled, finishVisible } = useNavigationEligibility();
  const {
    currentQuestion,
    activeStep,
    handleNext,
    handlePrev,
    questions,
    isDrawerOpen,
    surveyTitle,
    saveResponses,
    isSaving,
    activeParticipants,
  } = useSurveyDrawerControllerContext();

  if (!currentQuestion) return <></>;
  return (
    <>
      <DebugPanel displayItem={{ currentQuestion: currentQuestion, isOpen: isDrawerOpen }} />
      <Drawer
        elevation={16}
        open={isDrawerOpen}
        anchor={'bottom'}
        variant="temporary"
        PaperProps={{
          elevation: 24,
          style: {
            borderRadius: '16px 16px 0 0',
            backgroundColor: 'rgba(255, 255, 255, .95)',
          },
        }}
      >
        <DebugPanel displayItem={currentQuestion} />
        <SurveyTitle title={surveyTitle} />
        <Container maxWidth={'md'}>
          <Question text={currentQuestion.text}></Question>
          <Grid container display={'flex'} flexDirection={'column'}>
            <MutuallyExclusiveResponse currentQuestion={currentQuestion}></MutuallyExclusiveResponse>
            <DropdownResponse currentQuestion={currentQuestion}></DropdownResponse>
            <MultiSelectResponse currentQuestion={currentQuestion}></MultiSelectResponse>
            <FreeTextResponse currentQuestion={currentQuestion}></FreeTextResponse>
            {/*<GoalResponse currentQuestion={currentQuestion}></GoalResponse>*/}
            <AccountabilityPartnerResponse
              currentQuestion={currentQuestion}
              activeParticipants={activeParticipants}
            ></AccountabilityPartnerResponse>
          </Grid>
        </Container>
        <MobileStepper
          variant={'dots'}
          steps={questions.length}
          position="static"
          activeStep={activeStep}
          backButton={
            <IconButton size={'medium'} disabled={!prevEnabled} color={'primary'} onClick={handlePrev}>
              <ArrowLeft /> Prev
            </IconButton>
          }
          nextButton={
            <Fragment>
              {!finishVisible && (
                <IconButton disabled={!nextEnabled} size={'medium'} color={'primary'} onClick={handleNext}>
                  Next <ArrowRight />
                </IconButton>
              )}
              {finishVisible && (
                <Button
                  size={'medium'}
                  variant={'contained'}
                  sx={{ fontSize: '24px', padding: '12px', marginRight: '8px', marginLeft: '-8px' }}
                  color={'primary'}
                  disabled={isSaving}
                  onClick={saveResponses}
                >
                  {isSaving ? 'Saving...' : 'Finish'}
                </Button>
              )}
            </Fragment>
          }
        />
      </Drawer>
    </>
  );
};
